import { register } from "@shared/services/propertyRendererRegistry";
import StatusTagRenderer from "@shared/components/tickets/components/StatusTagRenderer.vue";
import { assetManagementTicketType } from "./constants";

register({
  twinTypePattern: assetManagementTicketType,
  customId: "status",
  viewComponentTable: StatusTagRenderer,
  viewComponentDetail: StatusTagRenderer,
});
